import { createTRPCReact } from "@trpc/react-query";
import type { TrpcAppRouter } from "@sellar-io/api-v2/trpc";
import { inferRouterOutputs } from "@trpc/server";

export type TrpcRouterOutput = inferRouterOutputs<TrpcAppRouter>;

export const trpc = createTRPCReact<TrpcAppRouter>();
